// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_dd-b";
export var colorBlue = "_dd-8";
export var colorDot = "_dd-0";
export var colorDotLarge = "_dd-2";
export var colorDotSmall = "_dd-1";
export var colorGreen = "_dd-7";
export var colorGrey = "_dd-3";
export var colorOrange = "_dd-5";
export var colorPink = "_dd-a";
export var colorPurple = "_dd-9";
export var colorRed = "_dd-4";
export var colorYellow = "_dd-6";